import { render, staticRenderFns } from "./WaveSurfer.vue?vue&type=template&id=a6eac326&"
import script from "./WaveSurfer.vue?vue&type=script&lang=js&"
export * from "./WaveSurfer.vue?vue&type=script&lang=js&"
import style0 from "./WaveSurfer.vue?vue&type=style&index=0&id=a6eac326&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports